export default __webpack_public_path__ + "static/media/demo.e2ce93d9.png";